const transactionSource = {
  MQ: 'Marqeta',
  BOTH: 'Both',
};

export default transactionSource;
